import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { registerPWA } from "./lib/registerPWA";
import { registerAdminUserFilters } from "./lib/adminUserFilters";
import { registerAdminRequestFilters } from "./lib/adminRequestFilters";
import { registerCareRequestPublicFilters } from "./lib/careRequestPublicFilters";
import { registerCareGrowthRuntime } from "./lib/careGrowthRuntime";
import { registerAdminSocialAgentEntry } from "./lib/registerAdminSocialAgentEntry";
import ErrorBoundary from "./components/ErrorBoundary";

// Log global des erreurs non capturées pour éviter les écrans blancs silencieux
if (typeof window !== "undefined") {
  window.addEventListener("error", (e) => {
    console.error("[global error]", e.message, e.error);
  });
  window.addEventListener("unhandledrejection", (e) => {
    console.error("[unhandled rejection]", e.reason);
  });
}

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </ErrorBoundary>
);

// Filtres supplémentaires des listes admin.
registerAdminUserFilters();
registerAdminRequestFilters();

// Accès direct à l'Agent Réseaux depuis le tableau de bord Administration.
registerAdminSocialAgentEntry();

// Section Annonces : filtres + matching, vues, statuts, statistiques et alertes.
registerCareRequestPublicFilters();
registerCareGrowthRuntime();

// Register PWA service worker — only in production, never in iframes/preview
registerPWA();
